import axios from 'axios';
import { API3_HOST } from 'helpers/urlHelper';

const API_BASE = `${API3_HOST}/service-desk`

export const sdGetHealth = () => axios.get(`${API_BASE}/health`);
// Me
export const sdGetMe = () => axios.get(`${API_BASE}/api/user/me`);

// Users
export const sdGetUsers = (projectId) => axios.get(`${API_BASE}/api/user?projectId=${projectId}`);
export const sdGetUser = (userId) => axios.get(`${API_BASE}/api/user/${userId}`);
export const sdCreateOrUpdateCustomer = (email, projectId) => axios.post(`${API_BASE}/api/user`, {'projectId' : projectId, 'email' : email});
// Projects
export const sdGetProjects = () => axios.get(`${API_BASE}/api/project`);
export const sdUpdateProject = (projectId, updateData) => axios.put(`${API_BASE}/api/project/${projectId}`, updateData);
export const sdGetProject = (projectId) => axios.get(`${API_BASE}/api/project/${projectId}`);
export const sdGetProjectMailboxLoginUrl = (projectId) => axios.get(`${API_BASE}/api/project/${projectId}/mailbox/loginUrl`);

// Priorities
export const sdGetAllPriorities = () => axios.get(`${API_BASE}/api/priority`);

// Issue
export const sdCreateIssue = (payload) => axios.post(`${API_BASE}/api/issue/`, payload);

export const sdGetIssue = (issueId) => axios.get(`${API_BASE}/api/issue/${issueId}`);

export const sdUpdateIssue = (issueId, updateData) => axios.put(`${API_BASE}/api/issue/${issueId}`, updateData);

export const sdAddCommentToIssue = (issueId, content, contentType='text/html', sendEmail = false) => axios.post(`${API_BASE}/api/comment`, 
    {'issueId': issueId, 'content' : content, 'contentType' : contentType, 'sendEmail' : sendEmail});

// Queue
export const sdGetQueue = (projectId, queueType) => axios.get(`${API_BASE}/api/queue?projectId=${projectId}&queueType=${queueType}`);

// Attachment
export const sdGenerateAttachmentDownloadURL = (attachmentId) => axios.get(`${API_BASE}/api/attachment/download/${attachmentId}`);

// Activities
export const sdGetActivitiesForProject = (projectId) => axios.get(`${API_BASE}/api/activity/${projectId}`);

// Board
export const sdGetBoardForProject = (projectId) => axios.get(`${API_BASE}/api/board/${projectId}`);